<div class="flex gap-2 justify-end pr-[0.25em]">
  <app-pan-button
    color="info"
    icon="comment"
    fill="outline"
    appTrackReviewActivity
    [appTrackReviewActivity]="reviewId"
    [appTrackReviewActivityAccessType]="'case'"
    [appTrackReviewActivityValue]="'comments'"
    (click)="commentsModal.show()"
    >Comments</app-pan-button
  >

  <a panButton [routerLink]="['/shared', 'investigation', reviewId]" target="_blank" color="info" icon="open_in_new">Details</a>
</div>

<app-pan-modal #commentsModal>
  <div header>Comments</div>

  <p body class="whitespace-normal">
    {{ comments }}
  </p>

  <div footer>
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
